import router from '@/router'
import { LOGIN_PAGES } from '../constants'
/**
 * 跳转去登录
 */
export const getLoginPath = (data) => {
    const baseLoginPath = router.currentRoute.value.meta.loginPage || LOGIN_PAGES.DEFAULT
    switch(baseLoginPath) {
        case LOGIN_PAGES.BIND_LOGIN: {
            return getBindLoginPagePath(baseLoginPath, data)
        }
        default: {
            return getDefaultLoginPagePath(LOGIN_PAGES.DEFAULT, data)
        }
    }
}

const getBindLoginPagePath = (baseLoginPath, { redirect: fixedRedirect } = {}) => {
    let redirect = fixedRedirect
    // redirect 默认获取
    if (!redirect) {
        redirect = encodeURIComponent(location.pathname + location.search)
    }
    return `${baseLoginPath}?redirect=${redirect}`
}

const getDefaultLoginPagePath = (baseLoginPath, { loginsys: fixedLoginsys, redirect: fixedRedirect } = {}) => {
    let loginsys = fixedLoginsys
    let redirect = fixedRedirect
    // loginsys 默认获取
    if (!loginsys) {
        loginsys = location.pathname.substring(1).split('/')[0]
        if (loginsys === 'no-auth') {
            const reason = ((location.search.substring(1).split('&').find(e => e.includes('reason')) || '').split('=')[1]) || ''
            if (reason.toLocaleLowerCase().includes('okr')) {
                loginsys = 'okr'
            }
            else if (reason.toLocaleLowerCase().includes('perf')) {
                loginsys = 'perf'
            }
        }
        if (!loginsys || (loginsys !== 'okr' && loginsys !== 'perf')) { loginsys = 'okr' }
    }
    // redirect 默认获取
    if (!redirect) {
        redirect = encodeURIComponent(location.pathname.includes(baseLoginPath) ? `/${loginsys}` : (location.pathname + location.search))
    }
    return `${baseLoginPath}?loginsys=${loginsys}&redirect=${redirect}`
}